export const getColorScheme = (color?: string | null) => {
  switch (color?.toLowerCase()) {
    case 'operations hub':
      return {
        gradientStart: 'rgb(254, 243, 226)',
        iconBackground: '#F6A61E',
      }
    case 'finance hub':
      return {
        gradientStart: 'rgb(233, 241, 254)',
        iconBackground: '#5596F6',
      }
    case 'talent hub':
      return {
        gradientStart: 'rgb(250, 231, 228)',
        iconBackground: '#E61942',
      }
    default:
      return {
        gradientStart: 'rgb(250, 231, 228)',
        iconBackground: '#E61942',
      }
  }
}
